import { FALLBACK_IMAGES } from '@/app/lib/constants/fallbackImages'

/** Duración de una slide sin vídeo antes de avanzar automáticamente (FR-013). */
export const NO_VIDEO_SLIDE_DURATION_MS = 3000

/** Tope de una slide CON vídeo, aunque el vídeo dure más y no haya terminado
 * (`ENDED`) — el CMS puede traer vídeos muy largos, y el carrusel no debe
 * quedarse bloqueado en una sola slide todo ese tiempo. */
export const MAX_VIDEO_SLIDE_DURATION_MS = 15000

/** Plazo máximo, desde que una slide con vídeo pasa a ser la activa, para que
 * su reproductor esté listo (`onReady`). Si no lo consigue a tiempo, esa
 * pasada renuncia al vídeo y se trata como una slide sin vídeo (imagen +
 * `NO_VIDEO_SLIDE_DURATION_MS`) en vez de esperar hasta el tope de
 * `MAX_VIDEO_SLIDE_DURATION_MS` sin mostrar nada. */
export const VIDEO_READY_TIMEOUT_MS = 2000

/** Cuánto se retrasa la revelación visual del vídeo (paso a
 * `isVideoPlaying: true`) después de llamar a `playVideo()` — NO retrasa la
 * llamada en sí. YouTube pinta su icono de play/pausa en el centro del
 * vídeo al arrancar la reproducción (chrome del iframe, cross-origin —
 * ningún selector CSS lo alcanza) y tarda 3-4s en desaparecer (comprobado en
 * vivo); este margen deja que termine mientras el póster de fondo sigue
 * visible, antes de revelar el vídeo. */
export const VIDEO_PLAY_ICON_FADE_MS = 4000

/** Debe coincidir con la transición `opacity` de `.videoSlot`/`.backgroundImage`
 * en `HeroCarousel.module.scss` — el player que deja de verse se destruye
 * (libera el iframe) solo después de que el fundido CSS haya tenido tiempo
 * de completarse, para que el vídeo se desvanezca en vez de desaparecer de
 * golpe (mismo cross-fade que el fondo). */
export const VIDEO_CROSSFADE_MS = 800

/** Etiqueta visual del evento marcado como `highlighted` (FR-012). */
export const HIGHLIGHTED_LABEL = 'Evento destacado'

/** Prefijo del precio orientativo ("Desde X €"). */
export const PRICE_FROM_PREFIX = 'Desde'

/** Texto del CTA de cada slide. */
export const CTA_LABEL = 'Ver entradas'

/** Fondos panorámicos de respaldo cuando el evento no trae asset
 * `panoramico` (FR-009) — repartidos en round-robin entre los eventos sin
 * imagen de una misma respuesta, sin repetir la misma en slides consecutivas
 * (`normalizeHeroCarouselItems`). Promovido a
 * `@/app/lib/constants/fallbackImages` (compartido con el módulo `Video` —
 * `specs/040-video-module/research.md` §6); se re-exporta aquí bajo su
 * nombre original para no tocar el resto de ficheros de `HeroCarousel`. */
export const NOT_FOUND_PANORAMIC_IMAGES = FALLBACK_IMAGES

/** Mínimo de eventos válidos para que el HeroCarousel se renderice (FR-002). */
export const MIN_VALID_ITEMS = 2

/** Etiqueta accesible del carrusel. */
export const SECTION_LABEL = 'Eventos destacados'

/**
 * Analítica (`components-fingerprint/Carousel.csv`, módulo transversal —
 * aplica a este carrusel en cualquier página que lo monte, no solo la Home).
 * `module_position: '1'`: el carrusel siempre es la primera pieza de
 * contenido de la página que lo aloja (Home, categoría) — a diferencia de
 * otros módulos posicionados por el orden dinámico de `page.modules[]` del
 * CMS, este valor es determinista.
 */
export const CAROUSEL_ANALYTICS_MODULE_NAME = 'carousel'
export const CAROUSEL_ANALYTICS_MODULE_TYPE = 'hero_carousel'
export const CAROUSEL_ANALYTICS_MODULE_POSITION = '1'

/**
 * `creative_name`/`creative_slot` de `view_promotion`/`select_promotion` —
 * valores LITERALES del único ejemplo de `Carousel.csv` (`banner_doble_portada`/
 * `cover`). El CSV no documenta un enum de valores alternativos ni un campo
 * del CMS del que derivarlos por slide, así que se usan fijos para todas las
 * piezas del carrusel — ⚠️ PROVISIONAL si en el futuro el CMS distingue varias
 * plantillas visuales de banner.
 */
export const CAROUSEL_CREATIVE_NAME = 'banner_doble_portada'
export const CAROUSEL_CREATIVE_SLOT = 'cover'
